import { Box, Grid, Typography } from '@mui/material'

import PlainHeader from '@ecm/ui/component/block/PlainHeader'
import Anchor from '@ecm/ui/element/Anchor'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import MainContainer from '@ecm/ui/element/MainContainer'
import DefaultLayout from '@ecm/ui/layout/Default'

type PartnerPreviewProps = {
  children: React.ReactNode
  href: string
  logo: string
}

const PartnerPreview = ({ children, href, logo }: PartnerPreviewProps) => (
  <Grid container direction="column" alignItems="start" margin="1em 0" width="100%">
    <Box width="100%" height="3em" position="relative" mb="1em">
      <CloudflareImage src={`/images/logo/${logo}.svg`} layout="fill" />
    </Box>
    {children}
    <Anchor external caret href={href}>
      Visit Website
    </Anchor>
  </Grid>
)

export const PartnershipsPage = () => (
  <DefaultLayout seoPage="company/partnerships">
    <PlainHeader title=" Modernize your business with Earth Class Mail and our partners">
      <Typography variant="p2" textAlign="center" maxWidth="40em">
        We partner with six companies committed to helping your business succeed. Our partners offer
        you the tools and support you need to tackle productivity, security and digitization
        challenges.
      </Typography>
    </PlainHeader>

    <MainContainer sx={{ paddingY: '4em' }}>
      <Grid
        display="grid"
        gap="2em"
        gridTemplateColumns={{ lg: '1fr 1fr 1fr', md: '1fr 1fr', sm: '1fr' }}
      >
        <PartnerPreview logo="stripe-atlas" href="https://stripe.com/atlas">
          <Typography variant="p2">
            A powerful, safe, and easy-to-use platform for forming a company. By removing lengthy
            paperwork, legal complexity, and numerous fees, Stripe Atlas helps companies launch
            their startups from anywhere in the world — using a best-in-class legal structure that’s
            built for scale.
          </Typography>
        </PartnerPreview>

        <PartnerPreview logo="filevine" href="https://www.filevine.com/">
          <Typography variant="p2" mb="0.5em">
            Filevine is a cloud-based software that provides case, matter, investigation, and
            project management software to over 15,000 legal professionals who manage millions of
            matters everyday.
          </Typography>
          <Typography variant="p2">
            It also provides users the ability to automate workflows, create deadline chains, use
            automated document generation, and do more in less time from any location.
          </Typography>
        </PartnerPreview>

        <PartnerPreview logo="relay" href="https://relayfi.com/?referralcode=EarthClassMail">
          <Typography variant="p2">
            Relay is small business banking made easy. With Relay, customers can effortlessly
            collaborate with team members, manage payments, and issue corporate cards — all from
            their bank.
          </Typography>
        </PartnerPreview>

        <PartnerPreview logo="growrk" href="https://growrk.com/">
          <Typography variant="p2">
            GroWrk helps companies provide the best remote work experience for their distributed
            teams. They equip employees with premium ergonomic home workstations and remote services
            available on a low monthly subscription.
          </Typography>
        </PartnerPreview>

        <PartnerPreview logo="justice-hq" href="https://justicehq.com/">
          <Typography variant="p2">
            Justice HQ is a membership of elite consumer advocate attorneys, who get the resources
            and opportunities to innovate, collaborate, and grow their careers. Members receive
            access to tech-based solutions for the modern trial attorney, integrated into the
            Justice HQ platform, as well as members-only networking and education opportunities.
          </Typography>
        </PartnerPreview>
      </Grid>
    </MainContainer>
  </DefaultLayout>
)

export default PartnershipsPage
